/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import AlquilerDestacados from "../components/UI/Home/AlquilerDestacados";
import TourDestacados from "../components/UI/Home/TourDestacados";
import { URL_API } from "../config/default";
import imgAlojamiento from "../assets/img/alojamiento-portada.webp";
import imgExcursion from "../assets/img/excursion-portada.webp";
import { useAppContext } from "../contexts/AppProvider";
import { myHeaders } from "../config/axios";
import SEO from "../components/SEO";

const Home = () => {
  const { me, banners }: any = useAppContext();

  const {
    isPending: isPendingFavoritos,
    error: errorFavoritos,
    data: favoritos,
  } = useQuery({
    queryKey: ["favoritos"],
    queryFn: () => {
      const requestOptions = {
        headers: {
          Authorization: myHeaders,
        },
      };
      return fetch(`${URL_API}/favorites`, requestOptions).then((res) =>
        res.json()
      );
    },
  });

  if (isPendingFavoritos) return "";

  if (errorFavoritos) return "";

  const banner_alquiler = banners
    ? banners.filter((b: any) => b.location == "banner-home-alquiler")
    : [];

  const banner_excursion = banners
    ? banners.filter((b: any) => b.location == "banner-home-excursion")
    : [];
  return (
    <div className="mx-auto border-0 w-[100%] min-h-screen">
      <SEO
        title="Rumbo Punilla - Plataforma de Alojamientos y Excursiones"
        description="Descubre los mejores alojamientos y excursiones. Encuentra tu lugar perfecto para quedarte y las mejores actividades turísticas en tu destino."
        name="Rumbo Punilla"
        type="website"
        canonicalUrl={window.location.href}
        keywords="alojamientos, excursiones, turismo, viajes, hoteles, tours, actividades, vacaciones"
        image={imgAlojamiento}
        twitterHandle="@tu_usuario_twitter"
      />

      <div className="w-full mx-auto px-1 md:px-4 mb-5">
        <div className="overflow-hidden w-full">
          <AlquilerDestacados user={me} favoritos={favoritos} />
        </div>
      </div>

      <div className="w-full mb-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
          <div className="w-full overflow-hidden">
            <Link to="/alojamientos">
              <div className="w-full relative inline-block text-center hover:scale-110 transition-transform duration-300">
                <img
                  src={
                    banner_alquiler.length > 0
                      ? banner_alquiler[0].url
                      : imgAlojamiento
                  }
                  className="w-full object-cover h-[500px]"
                  alt="Lista de alojamientos"
                  loading="lazy"
                />
                <div
                  className="absolute top-[50%] left-[50%] text-4xl font-bold text-white"
                  style={{ transform: "translate(-50%, -50%)" }}
                >
                  Alojamientos
                </div>
              </div>
            </Link>
          </div>
          <div className="w-full overflow-hidden">
            <Link to="/excursiones">
              <div className="w-full relative inline-block text-center hover:scale-110 transition-transform duration-300">
                <img
                  src={
                    banner_excursion.length > 0
                      ? banner_excursion[0].url
                      : imgExcursion
                  }
                  className="w-full object-cover h-[500px]"
                  alt="Lista de excursiones"
                  loading="lazy"
                />
                <div
                  className="absolute top-[50%] left-[50%] text-4xl font-bold text-white"
                  style={{ transform: "translate(-50%, -50%)" }}
                >
                  Excursiones
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div className="w-full mx-auto px-1 md:px-4 mb-5">
        <div className="overflow-hidden w-full">
          <TourDestacados user={me} favoritos={favoritos} />
        </div>
      </div>
    </div>
  );
};

export default Home;
